import { makeStyles } from '~/UIKit/Style';
import { EVENT_Z_INDEX } from '~/Screens/Calendar/constants';

export const useStyles = makeStyles(
  () => ({
    container: {
      zIndex: EVENT_Z_INDEX + 1,
      position: 'absolute',
      height: 0,
      cursor: 'pointer',
    },
    canDrag: {
      cursor: 'grab',
      '&:active': {
        cursor: 'grabbing',
      },
    },
  }),
  { name: 'DraggableEvent' },
);
